import { render, staticRenderFns } from "./CostAllocation.vue?vue&type=template&id=4e792dc0&scoped=true&"
import script from "./CostAllocation.vue?vue&type=script&lang=js&"
export * from "./CostAllocation.vue?vue&type=script&lang=js&"
import style0 from "./CostAllocation.vue?vue&type=style&index=0&id=4e792dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e792dc0",
  null
  
)

export default component.exports